import { render, staticRenderFns } from "./MobileElaboration.vue?vue&type=template&id=7f7d1ea1&scoped=true"
import script from "./MobileElaboration.vue?vue&type=script&lang=js"
export * from "./MobileElaboration.vue?vue&type=script&lang=js"
import style0 from "./MobileElaboration.vue?vue&type=style&index=0&id=7f7d1ea1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7d1ea1",
  null
  
)

export default component.exports